var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 1.01345C30 1.01345 27.3399 2.60777 25.8609 3.05985C25.067 2.13364 24.0119 1.47716 22.8384 1.1792C21.6648 0.88125 20.4293 0.956198 19.2991 1.39391C18.1689 1.83162 17.1984 2.61098 16.5189 3.62658C15.8395 4.64218 15.4838 5.84501 15.5 7.07241V8.40992C13.1835 8.47087 10.888 7.94957 8.81815 6.89244C6.74825 5.83531 4.87401 4.40907 3.54223 2.48487C3.54223 2.48487 -1.63636 14.3886 10.2273 19.7387C7.51251 21.6085 4.27853 22.5461 1 22.4137C12.8636 29.1013 27.3636 22.4137 27.3636 7.03228C27.3636 6.66045 27.3267 6.28862 27.2582 5.92214C28.6027 4.5766 30 1.01345 30 1.01345Z",
    stroke: "#9F9F9F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.a15df82fd22f5bf44c4b2ee8c4966b2b.svg";
export { ForwardRef as ReactComponent };